module.exports = __webpack_public_path__ + "static/media/dropdown_icon.f87d9e7d.svg";